module.exports = __webpack_public_path__ + "img/ic_24_playlist_delete.4324358a.svg";